import { MenuProps } from "@mui/material";

export const isInIframe = typeof window !== "undefined" && window.parent !== window;

// Disable autofocus in iframes because it's buggy in MUI - see https://github.com/mui/material-ui/issues/27584
export const iframeMenuProps: Partial<MenuProps> = isInIframe
    ? {
          autoFocus: false,
          disableAutoFocus: true,
          disableAutoFocusItem: true,
      }
    : {};

const toBinary = (s: string) => String.fromCharCode(...(new TextEncoder().encode(s) as unknown as Array<number>));

export const toBase64 = (s: string) => {
    if (typeof window === "undefined") {
        // Executing in NodeJS
        return new Buffer(s).toString("base64");
    }
    else {
        // Executing in the browser
        // btoa() takes only binary strings as input - see https://developer.mozilla.org/en-US/docs/Web/API/btoa#unicode_strings
        return window.btoa(toBinary(s));
    }
};
